import React from 'react';
import { useEffect, useState } from 'react';
import { getAppConfig } from '../../utils/configuration';
import { Box, CircularProgress } from '@mui/material';

export const CenteredProgress = () => (
  <Box>
    <CircularProgress color="primary" data-testid={'circular-progress'} />
  </Box>
);

export const Configuration = ({ children }: { readonly children: JSX.Element }) => {
  const config = getAppConfig();
  const [isConfigurationLoaded, setConfigurationLoaded] = useState(Boolean(config.itpUrl));

  useEffect(() => {
    if (!isConfigurationLoaded) {
      (async () => {
        try {
          const response = await fetch(`/configuration.json`);

          const data = await response.json();
          (window as Window).configuration = data;
          setConfigurationLoaded(true);
        } catch (error: unknown) {
          console.log(error);
        }
      })();
    }
  }, [isConfigurationLoaded]);

  return isConfigurationLoaded ? children : <CenteredProgress />;
};